module.exports = __webpack_public_path__ + "static/media/works5.2def74b0.png";